import { render, staticRenderFns } from "./ScrollableTable.vue?vue&type=template&id=3bd17835&"
import script from "./ScrollableTable.vue?vue&type=script&lang=js&"
export * from "./ScrollableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports